module.exports = __webpack_public_path__ + "media/97.e7aa6634.wav";